import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { ToggleProvider } from './context/ToggleContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ToggleProvider>

      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ToggleProvider>
  </React.StrictMode>
);
reportWebVitals();
